<template>
  <div>
    <!--    <div class="commitPaperDiv" v-if="authorityObj.isShow('#19#20#32')">-->
    <!--      &lt;!&ndash;    参会人权限才显示。&ndash;&gt;-->
    <!--      <el-button type="primary" icon="el-icon-plus"  @click="createPaper" size="mini">{{$t('common.commitPaper')}}</el-button>-->
    <!--    </div>-->
    <!--  搜索条件-->
    <div class="searchOutBox">
      <el-form
        :inline="true"
        ref="searchData"
        :model="searchData"
        class="demo-form-inline"
        size="mini"
      >
        <el-form-item :label="transZhEnDynamic('language') + ':'" width="10px">
          <el-select v-model="searchData.language" style="width: 90px">
            <el-option :label="transZhEnDynamic('all')" value=""></el-option>
            <el-option
              :label="transZhEnDynamic('ChinaWen')"
              value="2"
            ></el-option>
            <el-option
              :label="transZhEnDynamic('EnglishWen')"
              value="1"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="transZhEnDynamic('country') + ':'" width="10px">
          <el-select
            v-model="searchData.country"
            style="width: 90px"
            v-show="this.$store.state.dict.lang == 'zh'"
          >
            <el-option :label="transZhEnDynamic('all')" value=""></el-option>
            <!--          <el-option label="中国" value="ch"></el-option>-->
            <!--          <el-option label="英国" value="en"></el-option>-->
            <el-option
              v-for="(item, index) in $store.state.dict.AreaCountry"
              :key="index"
              :label="item.areaCountry"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select
            v-model="searchData.country"
            placeholder="chose"
            style="width: 90px"
            v-if="this.$store.state.dict.lang == 'en'"
          >
            <el-option :label="transZhEnDynamic('all')" value=""></el-option>
            <!--          <el-option label="中国" value="ch"></el-option>-->
            <!--          <el-option label="英国" value="en"></el-option>-->
            <el-option
              v-for="(item, index) in $store.state.dict.AreaCountry"
              :key="index"
              :label="item.areaCountryEn"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="transZhEnDynamic('DoubleCommit') + ':'"
          width="10px"
        >
          <el-select v-model="searchData.isDoubleCommit" style="width: 90px">
            <el-option :label="transZhEnDynamic('all')" value=""></el-option>
            <el-option :label="transZhEnDynamic('Yes')" value="1"></el-option>
            <el-option :label="transZhEnDynamic('No')" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="transZhEnDynamic('isEnabled') + ':'" width="10px">
          <el-select v-model="searchData.isEnabled" style="width: 90px">
            <el-option :label="transZhEnDynamic('all')" value=""></el-option>
            <el-option
              :label="transZhEnDynamic('HasEffect')"
              value="1"
            ></el-option>
            <el-option
              :label="transZhEnDynamic('NoEffect')"
              value="0"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          :label="transZhEnDynamic('evaluationResult') + ':'"
          width="10px"
        >
          <el-select v-model="searchData.evaluationResult" style="width: 90px">
            <el-option :label="transZhEnDynamic('all')" value=""></el-option>
            <el-option
              :label="transZhEnDynamic('evaluationResult1')"
              value="1"
            ></el-option>
            <el-option
              :label="transZhEnDynamic('evaluationResult2')"
              value="2"
            ></el-option>
            <el-option
              :label="transZhEnDynamic('evaluationResult3')"
              value="3"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 征文主题 -->
        <!-- <el-form-item :label="transZhEnDynamic('topic') + ':'" width="10px">
          <el-select v-model="searchData.topic" style="width: 90px">
            <el-option :label="transZhEnDynamic('all')" value=""></el-option>
            <el-option :label="$t('common.other')" value="其他"></el-option>
            <el-option
              v-for="(item, index) in $store.state.dict.currentMeetingtTopicArr"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item :label="transZhEnDynamic('Keywords') + ':'" width="20px">
          <el-select
            v-model="searchData.KeywordsType"
            :placeholder="transZhEnDynamic('Keywords')"
            style="width: 120px"
          >
            <el-option :label="transZhEnDynamic('all')" value=""></el-option>
            <el-option
              :label="transZhEnDynamic('docCode')"
              value="docCode"
            ></el-option>
            <el-option
              :label="transZhEnDynamic('title')"
              value="title"
            ></el-option>
            <el-option
              :label="transZhEnDynamic('authorCode')"
              value="authorCode"
            ></el-option>
            <el-option
              :label="transZhEnDynamic('jigou')"
              value="jigou"
            ></el-option>
            <el-option
              :label="transZhEnDynamic('Abstract')"
              value="Abstract"
            ></el-option>
          </el-select>
          <el-input
            v-model="searchData.Keywords"
            :placeholder="$t('common.pleaseInputValue')"
            style="width: 190px"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit" icon="el-icon-search">{{
            $t("common.search")
          }}</el-button>
          <el-button @click="resetForm" icon="el-icon-refresh">{{
            $t("common.reset")
          }}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="handleAllCla" v-if="false">
      <el-radio-group v-model="pageStates" size="mini">
        <el-radio label="1" border>{{ $t("common.allPaper") }}</el-radio>
        <el-radio label="2" v-if="authorityObj.isShow('#19#20#22')" border>{{
          $t("common.Tobeallocated")
        }}</el-radio>
        <el-radio label="3" border>{{ $t("common.Tobereviewed") }}</el-radio>
        <el-radio label="4" border>{{ $t("common.Reviewed") }}</el-radio>
      </el-radio-group>
    </div>
    <!--  新版样式-->
    <div class="handleAllClaOut">
      <div class="handleAllClaV2">
        <span
          :class="this.pageStates == '1' ? 'on' : ''"
          @click="changePageStates('1')"
          >{{ $t("common.allPaper") }}</span
        >
        <span
          v-if="authorityObj.isShow('#19#20#22')"
          :class="this.pageStates == '2' ? 'on' : ''"
          @click="changePageStates('2')"
          >{{ $t("common.Tobeallocated") }}</span
        >
        <span
          :class="this.pageStates == '3' ? 'on' : ''"
          @click="changePageStates('3')"
          >{{ $t("common.Tobereviewed") }}</span
        >
        <span
          :class="this.pageStates == '4' ? 'on' : ''"
          @click="changePageStates('4')"
          >{{ $t("common.Reviewed") }}</span
        >
      </div>
      <div class="handleAllRightCla">
        <el-form
          :inline="true"
          ref="searchData"
          :model="handleAllObj"
          class=""
          size="mini"
        >
          <el-form-item :label="transZhEnDynamic('sortType')" width="20px">
            <span slot="label">
              <span class="whiteSpan">
                <i class="el-icon-sort" />
              </span>
            </span>
            <el-select
              v-model="searchData.sortType"
              @change="requestDocList"
              placeholder=""
              style="width: 120px"
            >
              <el-option :label="transZhEnDynamic('all')" value=""></el-option>
              <el-option
                :label="transZhEnDynamic('time_desc')"
                value="time_desc"
              ></el-option>
              <el-option
                :label="transZhEnDynamic('time')"
                value="time"
              ></el-option>
              <el-option
                :label="transZhEnDynamic('doc_desc')"
                value="doc_desc"
              ></el-option>
              <el-option
                :label="transZhEnDynamic('doc')"
                value="doc"
              ></el-option>
              <el-option
                :label="transZhEnDynamic('evaluationResult_desc')"
                value="evaluationResult_desc"
              ></el-option>
              <el-option
                :label="transZhEnDynamic('evaluationResultSort')"
                value="evaluationResult"
              ></el-option>
              <el-option
                :label="transZhEnDynamic('finalScore_desc')"
                value="finalScore_desc"
              ></el-option>
              <el-option
                :label="transZhEnDynamic('finalScore')"
                value="finalScore"
              ></el-option>
            </el-select>
          </el-form-item>
          <span class="headinnerBtn" @click="requestDocList">{{
            $t("common.sort")
          }}</span>

          <el-form-item :label="transZhEnDynamic('batch') + ':'" width="200px">
            <span slot="label">
              <span class="whiteSpan">
                <i class="el-icon-document-copy" />
              </span>
            </span>
            <el-select
              v-model="handleAllObj.handle"
              placeholder="transZhEnDynamic('batch')+':'"
              style="width: 200px"
            >
              <el-option
                :label="transZhEnDynamic('ChoseBatch')"
                value=""
              ></el-option>
              <el-option
                :label="transZhEnDynamic('DownLoadXlsx')"
                value="excel"
              ></el-option>
              <el-option
                :label="transZhEnDynamic('DownLoadxZip')"
                value="zip"
              ></el-option>
            </el-select>
          </el-form-item>
          <span class="headinnerBtn" @click="handleAllFunc">{{
            $t("common.batch")
          }}</span>
        </el-form>
      </div>
    </div>
    <!--  搜索条件结束-->
    <!--  列表开始-->
    <div>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :empty-text="$t('common.noData')"
        :row-class-name="invalidClassFunc"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
        <el-table-column :label="transZhEnDynamic('docCode')">
          <template slot-scope="scope">
            <span class="span">{{ scope.row.docCode }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="transZhEnDynamic('title')">
          <template slot-scope="scope">
            <span class="span">{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="transZhEnDynamic('authorInfo')"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span class="span">{{ scope.row.authorInfo }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="meetingName"
          :label="$t('common.currentMeeting')"
        >
          <template slot-scope="scope">
            <span class="span">{{ $store.state.dict.lang === 'zh'? scope.row.meetingName:scope.row.meetingNameEn }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="transZhEnDynamic('topic')"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span class="span">{{ scope.row.topic }}</span>
          </template>
        </el-table-column>
        <!-- 屏蔽掉评审人信息 -->
        <!-- <el-table-column
          v-if="authorityObj.isShow('#19#67#73')"
          :label="transZhEnDynamic('reviewerMan')"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span :class="scope.row.reviewer ? 'span' : 'nullSpan'">{{
              IsNull(scope.row.reviewer)
            }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          v-if="authorityObj.isShow('#19#67#74')"
          :label="transZhEnDynamic('reviewerInfo')"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.reviewerStatus == 0" class="graySpan">{{
              $t("common.Tobereviewed")
            }}</span>
            <span
              v-else
              @click="lookOverOpinionFunc(scope.row)"
              style="cursor: pointer; color: green"
              >{{ $t("common.toSee") }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          v-if="authorityObj.isShow('#19#67#75')"
          :label="transZhEnDynamic('grade')"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.reviewerStatus == 1">
              <span class="span">{{ scope.row.finalScore }}</span>
            </span>
            <span v-else class="graySpan">{{ $t("common.Tobereviewed") }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="220"
          :label="transZhEnDynamic('reviewerResult')"
          v-if="authorityObj.isShow('#19#20#52')"
        >
          <template slot-scope="scope">
            <!-- <div v-if="!authorityObj.isShow('#19#20#52')">
              <span v-if="scope.row.evaluationResult==1||scope.row.evaluationResult==3">{{
                scope.row.evaluationResult | evaluationResultFilter
              }}</span>
              <span v-else-if="scope.row.evaluationResult ==2&&scope.row.reviewerStatus == 1">{{
                scope.row.evaluationResult | evaluationResultFilter
              }}</span>
              <span v-else class="graySpan">{{
                $t("common.Tobereviewed")
              }}</span>
            </div> -->
            <el-select
              v-if="authorityObj.isShow('#19#20#52')"
              v-model="scope.row.evaluationResult"
              @change="updateEvaluationResult(scope.row)"
              style="width: 100px"
              :placeholder="transZhEnDynamic('pleaseReviewer')"
            >
              <el-option
                :label="transZhEnDynamic('evaluationResult1')"
                :value="1"
              ></el-option>
              <el-option
                :label="transZhEnDynamic('evaluationResult2')"
                :value="2"
              ></el-option>
              <el-option
                :label="transZhEnDynamic('evaluationResult3')"
                :value="3"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column :label="transZhEnDynamic('handle')">
          <template slot-scope="scope">
            <!--   管理员才能 管理评审人 -->
            <div v-if="authorityObj.isShow('#19#20#48')">
              <span @click="managerReviewerMan(scope.row)" class="blueSpan">{{
                $t("common.manageReviewerMan")
              }}</span>
            </div>
            <div>
              <span class="blueSpan" @click="toDetailPage(scope.row)">{{
                $t("common.toSee")
              }}</span>
            </div>
            <div>
              <span @click="downLoad(scope.row)" class="blueSpan">{{
                $t("common.downLoad")
              }}</span>
            </div>
            <!--   评审员才能评审   -->
            <!-- 必须评审员未评审且管理员未接受或拒绝 -->
            <div
              v-if="
                authorityObj.isShow('#19#67#72') &&
                scope.row.reviewerStatus == 0 &&(scope.row.evaluationResult==2||scope.row.evaluationResult==null)
              "
            >
              <span class="blueSpan" @click="goReview(scope.row)">{{
                $t("common.toToReviewer")
              }}</span>
            </div>
            <!--   管理员才能设置无效论文   -->
            <div v-if="authorityObj.isShow('#19#20#49')">
              <span class="blueSpan" @click="changeIsEnabledFunc(scope.row)">{{
                scope.row.isEnabled == "1"
                  ? transZhEnDynamic("livePaper")
                  : transZhEnDynamic("notLivePaper")
              }}</span>
            </div>
            <!--            <div v-if="authorityObj.isShow('#19#20#50')"><span @click="editPaperFunc(scope.row)" class="blueSpan">{{$t('common.edit')}}</span></div>-->
          </template>
        </el-table-column>
      </el-table>
      <!--  分页-->
      <el-pagination
        v-if="tableData.length > 0"
        background
        size="min"
        layout="prev, pager, next"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        @current-change="handleCurrentChange"
        :hide-on-single-page="false"
        :total="totalCount"
      >
      </el-pagination>

      <div style="margin-top: 20px" v-if="false">
        <el-button @click="toggleSelection([tableData[1], tableData[2]])"
          >切换第二、第三行的选中状态</el-button
        >
        <el-button @click="toggleSelection()">取消选择</el-button>
      </div>
    </div>
    <manager-reviewer-man-component
      ref="reviewerManComponent"
      @clickQue="requestDocList"
    ></manager-reviewer-man-component>
    <look-over-opinion-component
      ref="lookOverOpinionRef"
    ></look-over-opinion-component>
  </div>
</template>

<script>
import managerReviewerManComponent from "@/components/paper/managerReviewerManComponent"; //管理评审人组件
import lookOverOpinionComponent from "@/components/paper/lookOverOpinionComponent";
import config from "../../api/config";
let that='';
export default {
  data() {
    return {
      this_:this,
      meetingCode: this.$store.state.dict.currentMeetingCode,
      // 分页
      pageNo: 1,
      pageSize: 10,
      totalCount: 10,
      // paramSingleDocCode:'',//点击管理评审人的参数
      searchData: {
        language: "",
        country: "",
        isDoubleCommit: "",
        isEnabled: "",
        evaluationResult: "",
        topic: "", //征文主题
        KeywordsType: "",
        Keywords: "", //关键字
        sortType: "", //排序方式
        name: "",
        isDistribution: "0",
      },
      pageStates: "1", // 1全部 ,2待分配 ,3待评审  ,4已评审          0：待评审1：已评审',
      handleAllObj: {
        handle: "",
      },
      //列表
      tableData: [
        // {
        //   docCode: '3232erwewew',
        //   title: '关于XX关于XX论文关于XX论文关于XX论文关于XX论文关',
        //   authorInfo: '王小虎',
        //   topic: '主题01',
        //   reviewer: '评审人1',
        //   evaluationAdvice: '评审意见001',
        //   finalScore: '90',
        //   evaluationResult: '1',//'1:接受2:待定3:拒绝',
        //   reviewerStatus: '0',// 0：待评审1：已评审',
        //   isEnabled: '1',//1有效 0无效',
        // }
      ],
      multipleSelection: [],
    };
  },
  computed: {
    currentMeetingCode() {
      return this.$store.state.dict.currentMeetingCode;
    },
  },
  watch: {
    currentMeetingCode() {
      this.meetingCode = this.$store.state.dict.currentMeetingCode;
      this.requestDocList();
    },
  },
  filters: {
    evaluationResultFilter(val) {
      //'1:接受2:待定3:拒绝',
      let returnstr = that.$t("common.evaluationResult2");
      if (val == 1) {
        returnstr = that.$t("common.evaluationResult1");
      } else if (val == 2) {
        returnstr = that.$t("common.evaluationResult2");
      } else if (val == 3) {
        returnstr = that.$t("common.evaluationResult3");
      }
      return returnstr;
    },
  },
  components: {
    managerReviewerManComponent,
    lookOverOpinionComponent,
  },
  mounted() {
    that = this;
    this.requestDocList();
  },
  methods: {
    changePageStates(val) {
      this.pageStates = val;
      this.requestDocList();
    },
    /**
     * 请求相关
     * */
    //评审结果更新
    updateEvaluationResult(item) {
      let data = {};
      data.docCodeList = [item.docCode];
      data.evaluationResult = item.evaluationResult;
      this.$api.updateEvaluationResult(data).then((res) => {
        this.$message.success(this.$t("msg.successMsg"));
      });
    },
    getReviewerStatus() {
      let resstatus = "";
      if (this.pageStates == "3") {
        resstatus = "0";
      } else if (this.pageStates == "4") {
        resstatus = "1";
      }
      return resstatus;
    },
    //请求列表。
    requestDocList() {
      let data = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        // flag:0,//参会人2   管理员0
        roleCode: this.$store.state.user.currentRoleCode,
        meetingCode: this.meetingCode,

        language: this.searchData.language,
        country: this.searchData.country,
        isDoubleCommit: this.searchData.isDoubleCommit,
        isEnabled: this.searchData.isEnabled,
        evaluationResult: this.searchData.evaluationResult,
        topic: this.searchData.topic, //征文主题
        orderBy:
          this.searchData.sortType == ""
            ? "time_desc"
            : this.searchData.sortType, //排序方式
        name: this.searchData.name,
        isDistribution: this.pageStates == "2" ? "0" : "", //待分配
        reviewerStatus: this.getReviewerStatus(), //待评审、已评审

        // KeywordsType:this.searchData.KeywordsType,
        // Keywords:this.searchData.Keywords,//关键字
      };
      //添加关键字
      if (this.searchData.KeywordsType == "") {
        data.allSearch = this.searchData.Keywords;
      } else if (this.searchData.KeywordsType == "title") {
        data.title = this.searchData.Keywords;
      } else if (this.searchData.KeywordsType == "docCode") {
        data.docCode = this.searchData.Keywords;
      } else if (this.searchData.KeywordsType == "authorCode") {
        data.authorInfo = this.searchData.Keywords;
      } else if (this.searchData.KeywordsType == "Abstract") {
        data.abstract = this.searchData.Keywords;
      } else if (this.searchData.KeywordsType == "jigou") {
        data.authorOrgName = this.searchData.Keywords;
      }

      //添加了排序方式。
      // time_desc( "时间倒序，最新"),
      // time("时间正序","最老"),
      // doc_desc("论文编号倒序"),
      // doc("论文编号正序"),
      // evaluationResult_desc("接受《待定《拒绝"),
      // evaluationResult("接受》待定》拒绝"),
      // finalScore_desc("final_score DESC","分数降"),
      // finalScore("final_score ASC","分数升"),

      // if(this.authorityObj.isShow('#19#20#61')) {
      //   this.$api.selectUploadDocList(data).then((res) => {
      //     if (res.code == '200') {
      //       this.pageNo = res.data.pageNo
      //       this.totalCount = res.data.totalElements;
      //
      //       //作者名称  数组转为字符串
      //       res.data.data.some((x) => {
      //         x.authorInfo = '';
      //         x.userList.author.some((y) => {
      //           x.authorInfo += y.userName + ";";
      //         })
      //
      //         x.reviewer = '';
      //         x.userList.reviewer.some((z) => {
      //           x.reviewer += z.userName + ";";
      //         })
      //       })
      //       this.tableData = res.data.data;
      //     }
      //   })
      // }
      //权限 评审人
      //评审人请求表格接口  #19#20#62
      if (this.authorityObj.isShow("#19#67#76")) {
        data.createUser = this.$store.state.user.currentUserId;
        this.$api.selectEvaluationDocList(data).then((res) => {
          if (res.code == "200") {
            this.pageNo = res.data.pageNo;
            this.totalCount = res.data.totalElements;

            //作者名称  数组转为字符串
            res.data.data.some((x) => {
              x.authorInfo = "";
              x.authorList.some((y) => {
                x.authorInfo += y.name + ";";
              });

              x.reviewers = "";
              x.reviewerList=x.reviewerList||[]
              x.reviewerList.some((z) => {
                x.reviewers += z.userName + ";";
              });

              x.reviewerStatus =
                x.distributionEvaluationStatus == "0" ? "0" : "1";
            });
            this.tableData = res.data.data;
            // console.log(this.tableData)
          }
        });
      }
    },
    //点击查询
    onSubmit() {
      this.requestDocList();
    },
    //分页查询
    handleCurrentChange() {
      console.log(this.pageNo);
      this.requestDocList();
    },
    //参会人 提交论文
    createPaper() {
      this.$router.push({
        path: "/Submit",
      });
    },
    //参会人 编辑论文
    editPaperFunc(row) {
      this.$router.push({
        path: "/editPaper",
        query: {
          id: row.docCode,
        },
      });
    },
    /**
     * 列表相关
     * */
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //下载
    downLoad(row) {
      // let data = {};
      // data.meetingCode = this.meetingCode;
      // data.docCodeList = [];
      // data.docCodeList.push(row.docCode);
      // this.$api.docDownload(data).then((res) => {});
      window.open(row.fileName);
    },
    //管理评审人
    managerReviewerMan(row) {
      this.$refs["reviewerManComponent"].handleOpen(row.docCode);
      console.log("管理评审人" + row);
    },
    //结束------------------------------------------------------
    handleAllFunc() {
      let url = config.baseURL + "/crDoc/export";
      const meetingCode =
        this.$store.state.user.currentRoleCode != "#ROLE1" &&
        this.$store.state.user.currentRoleCode != "#ROLE1#ROLE2"
          ? this.searchData.meetingCode
          : this.meetingCode;
      let data = {
        // flag:0,//参会人2   管理员0
        roleCode: this.$store.state.user.currentRoleCode,
        meetingCode: meetingCode,
        token: localStorage.getItem("authorization"),
        language: this.searchData.language,
        country: this.searchData.country,
        isDoubleCommit: this.searchData.isDoubleCommit,
        isEnabled: this.searchData.isEnabled,
        evaluationResult: this.searchData.evaluationResult,
        topic: this.searchData.topic, //征文主题
        orderBy:
          this.searchData.sortType == ""
            ? "time_desc"
            : this.searchData.sortType, //排序方式
        name: this.searchData.name,
        isDistribution: this.pageStates == "2" ? "0" : "", //待分配
        reviewerStatus: this.getReviewerStatus(), //待评审、已评审

        // KeywordsType:this.searchData.KeywordsType,
        // Keywords:this.searchData.Keywords,//关键字
      };
      //添加关键字
      if (this.searchData.KeywordsType == "") {
        data.allSearch = this.searchData.Keywords;
      } else if (this.searchData.KeywordsType == "title") {
        data.title = this.searchData.Keywords;
      } else if (this.searchData.KeywordsType == "docCode") {
        data.docCode = this.searchData.Keywords;
      } else if (this.searchData.KeywordsType == "authorCode") {
        data.authorInfo = this.searchData.Keywords;
      } else if (this.searchData.KeywordsType == "Abstract") {
        data.abstract = this.searchData.Keywords;
      } else if (this.searchData.KeywordsType == "jigou") {
        data.authorOrgName = this.searchData.Keywords;
      }
      //下载excel文件
      if (this.handleAllObj.handle == "excel") {
        var form = document.createElement("form");
        for (const item in data) {
          var opt = document.createElement("input");
          // 设置相应参数
          opt.name = item;
          opt.value = data[item];
          form.appendChild(opt);
        }
        document.body.appendChild(form);
        form.method = "post";
        form.action = url;
        form.submit();
        document.body.removeChild(form);
      } else if (this.handleAllObj.handle == "zip") {
        this.$api
        .downloadZip(data).then((res) => {
            this.downloadFile(res);
          });
      }
    },
    downloadFile(data) {
      let blob = new Blob([data.data], { type: "application/zip" });
      let url = window.URL.createObjectURL(blob);
      console.log(url)
      const link = document.createElement("a"); // 创建a标签
      link.href = url;
      link.download = "fileDown"; // 重命名文件
      link.click();
      URL.revokeObjectURL(url); // 释放内存
    },
    resetForm() {
      // this.$refs['searchData'].resetFields();
      this.searchData = {
        language: "",
        country: "",
        isDoubleCommit: "",
        evaluationResult: "",
        topic: "", //征文主题
        KeywordsType: "",
        Keywords: "", //关键字
        sortType: "", //排序方式
        name: "",
        isEnabled: "",
      };
    },
    //设置无效class  //1有效 0无效',
    invalidClassFunc(val) {
      if (val.row.isEnabled == "0") {
        return "invalidCla";
      } else {
        return "";
      }
    },
    //切换无效论文
    changeIsEnabledFunc(item) {
      let data = {
        docCode: item.docCode,
        isEnabled: item.isEnabled == "0" ? 1 : 0,
      };
      this.$api.updateDocisEnabled(data).then((res) => {
        if (res.code == "200") {
          if (item.isEnabled == "0") {
            item.isEnabled = "1";
          } else if (item.isEnabled == "1") {
            item.isEnabled = "0";
          }
          this.$message.success("设置成功");
        } else {
          this.$message.success("设置失败");
        }
      });
    },
    //查看意见
    lookOverOpinionFunc(item) {
      this.$refs["lookOverOpinionRef"].handleOpen(item);
    },
    toDetailPage(row) {
      this.$router.push({
        path: "/detailPaper",
        query: {
          id: row.docCode,
        },
      });
    },
    goReview(row) {
      this.$router.push({
        path: "/reviewPaper",
        query: {
          id: row.docCode,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.commitPaperDiv {
  background: #e3ebff;
  margin: -10px 0 10px -10px;
  padding: 10px 0 0 10px;
}
.search-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  align-items: center;
  .search-in {
    display: flex;
    justify-content: left;
    align-items: center;
    span {
      width: 80px;
    }
  }
}
.searchOutBox {
  background: rgba(55, 116, 254, 0.14);
  padding: 20px 20px 0 20px;
  margin: -10px 0 0 -10px;
  .el-form-item {
    margin-right: 60px;
  }
}
//无效样式。
.invalidCla {
  .span {
    text-decoration: line-through;
    color: $defaultColor;
  }
  .graySpan {
    text-decoration: line-through;
  }
}
.handleAllClaOut {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #3774fe;
  margin-left: -10px;
  padding-left: 10px;
  height: 64px;
  .handleAllClaV2 {
    display: flex;
    justify-content: left;
    align-items: center;
    height: 100%;
    font-size: 16px;
    span {
      display: flex;
      justify-content: left;
      align-items: center;
      box-sizing: border-box;
      height: 100%;
      color: #bbb7b7ff;
      margin-right: 20px;
      cursor: pointer;
      border-bottom: 3px solid rgba(0, 0, 0, 0);
    }
    span.on {
      color: #fff;
      border-bottom: 3px solid #fff;
    }
    span:hover {
      color: #fff;
      border-bottom: 3px solid #fff;
    }
  }
  .handleAllRightCla {
    display: flex;
    align-items: center;
    .el-form-item {
      margin-bottom: 0 !important;
    }
    .headinnerBtn {
      display: inline-block;
      border-radius: 4px;
      height: 27px;
      margin: 2px 30px 0 0;
      padding: 0 20px;
      text-align: center;
      line-height: 27px;
      color: #fff;
      background: #85a1e2;
      cursor: pointer;
    }
    .headinnerBtn:hover {
      background: #7e9be2;
    }
  }
}
</style>
